import { render } from "./EmployeePositionRegister.vue?vue&type=template&id=741c3a9f"
import script from "./EmployeePositionRegister.vue?vue&type=script&lang=js"
export * from "./EmployeePositionRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__